import { render, staticRenderFns } from "./SitePopup.vue?vue&type=template&id=2ca6f30a&"
import script from "./SitePopup.vue?vue&type=script&lang=js&"
export * from "./SitePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports